"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emotion_1 = require("../emotion");
class BaseScene extends Phaser.Scene {
    static calculateExpressionFromString(expression) {
        switch (expression) {
            case "happy":
                return emotion_1.Emotion.Happy;
                break;
            case "angry":
                return emotion_1.Emotion.Angry;
                break;
            case "neutral":
                return emotion_1.Emotion.NEUTRAL;
                break;
            case "surprised":
                return emotion_1.Emotion.Surprised;
                break;
            default:
                return null;
        }
    }
    update(time, delta) {
        if (!this._timeSinceLastDetect) {
            this._timeSinceLastDetect = 0;
        }
        this._timeSinceLastDetect += delta;
        if (this._timeSinceLastDetect > 300) {
            this._timeSinceLastDetect = 0;
            this.onLastDetectPassed();
        }
    }
    onLastDetectPassed() {
    }
}
exports.default = BaseScene;
